<template>
  <tr>
    <td>
      <button class="button" :disabled="isDeleting" @click="editFreight">
        <font-awesome-icon icon="edit" />
      </button>
    </td>
    <td>
      <button class="button is-warning" :class="{ 'is-loading': isDeleting }" :disabled="isDeleting" @click="removeFreight">
        <font-awesome-icon icon="trash-alt" />
      </button>
    </td>
    <td>
      <div v-if="documents.length" class="documents">
        {{ documents.length }} document(s) attached
        <button class="button" type="button" @click="toggleDocumentUpload">Edit Documents</button>
      </div>
      <template v-else>
        <button type="button" class="button" @click="toggleDocumentUpload">Add Documents</button>
      </template>
      <document-upload-modal v-model="documents" :show.sync="showDocumentUpload" :freight-key="freight.companyJobFreightKey" :can-pick-from-lib="false" />
    </td>
    <td>
        <b-select v-model="freight.originKey" class="location-select">
        <option v-for="location in origins" :value="location.companyJobPointKey" :key="location.temporaryId">
          {{ location.address.facilityName }}
        </option>
      </b-select>
    </td>
    <td>
      <b-select v-model="freight.destinationKey" class="location-select">
        <option v-for="location in destinations" :value="location.companyJobPointKey" :key="location.temporaryId">
          {{ location.address.facilityName }}
        </option>
      </b-select>
    </td>
    <td> {{ freight.companyJobFreightDescription }} </td>
    <td> {{ freight.companyJobFreightPallets }} </td>
  </tr>
</template>

<script>
import CompanyJobApi from '@/api-interface/companyjob'
import DocumentUploadModal from '@/components/DocumentUploadModal'
export default {
  name: 'FreightDescriber-row',

  model: {
    prop: 'freight',
    event: 'change'
  },

  props: {
    origins: {
      type: Array
    },
    destinations: {
      type: Array
    },
    freight: {
      type: Object
    }
  },

  created() {
    this.preselectJobPoints()
  },

  components: {
    DocumentUploadModal
  },

  data() {
    return {
      showDocumentUpload: false,
      isDeleting: false,
      // uploaded documents modify the target-object indirectly (poor design choice), so the parent would need to
      // re-fetch its data in order to see the updated document. Has a workaround... the added document is just stored
      // here but never passed up
      documents: []
    }
  },

  methods: {
    /**
     * Pre-select the first origin and first destination as the default values for all new line items
     */
    preselectJobPoints() {
      if (!this.freight.originKey && this.origins.length) {
        this.freight.originKey = this.origins[0].companyJobPointKey
      }

      if (!this.freight.destinationKey && this.destinations.length) {
        this.freight.destinationKey = this.destinations[0].companyJobPointKey
      }
    },
    toggleDocumentUpload() {
      this.showDocumentUpload = !this.showDocumentUpload
    },

    async removeFreight() {
      // for jobPoints that have already been saved... we need to call a different endpoint to delete them
      if (this.freight.companyJobFreightKey) {
        this.isDeleting = true
        await CompanyJobApi.deleteFreight(this.freight.companyJobFreightKey)
        this.isDeleting = false
      }

      this.$emit('delete', this.freight)
    },

    editFreight() {
      this.$emit('edit', this.freight)
    }
  },

  watch: {
    origins: 'preselectJobPoints',
    destinations: 'preselectJobPoints',
    'freight.companyJobFreightDocuments'() {
      this.documents = [...this.freight.companyJobFreightDocuments]
    }
  }
}
</script>

<style scoped lang="scss">
.location-select {
  width: 150px;
}

.documents {
  position: relative;

  .button {
    position: absolute;
    top: 5px;
    opacity: 0.8;
    display: none;
  }

  &:hover {
    .button {
      display: block;
    }
  }
}
</style>
